import { testBalanceInstances, dynamicInstances, useParamsUrlInstances, axiosInstance, live_instance } from "../instance";

/**===========================================直播节目========================================== */
// 获取分组列表
export const getGroupListApi = () => live_instance({method: 'get', url: `/netfly-admin/v1/live/group/list`, })

// 添加分组
export const addGroupApi = (data) => live_instance({method: 'post', url: `/netfly-admin/v1/live/group`, data, type: 'json' })

// 删除分组
export const deleteGroupApi = (groupId) => live_instance({method: 'delete', url: `/netfly-admin/v1/live/group/${groupId}`,  })

// 修改分组
export const updateGroupApi = (data) => live_instance({method: 'put', url: `/netfly-admin/v1/live/group/name`, data, type: 'json' })

// 获取错误类型列表
export const getErrorTypeOptionsApi = () => live_instance({method: 'get', url: `/netfly-admin/v1/live/error-log/error-types`,  })

// 获取错误日志列表
export const getErrorLogListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/error-log/statistics`, params })

// 添加频道到分组
export const addChannelToGroupApi = (data) => live_instance({method: 'post', url: `/netfly-admin/v1/live/group/program`, data, type: 'json' })

// 删除频道从分组
export const deleteChannelFromGroupApi = (data) => live_instance({method: 'delete', url: `/netfly-admin/v1/live/group/program`, data, type: 'json' })

// 查看频道详情
export const getChannelDetailApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/error-log/list`, params })

// 查询边缘节点
export const getEdgeNodeListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/error-log/node-list`, params })

/**===========================================播放监控============================================= */
// 直播节目
// 获取首帧时长统计
export const getFirstFrameStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/first-frame-delay`, params })

// 获取首帧时长的详情
export const getFirstFrameDelayDetailApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/first-frame-delay/list`, params })

// 获取首帧平均时长列表
export const getFirstFrameAverageDurationListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/first-frame-delay/avg/list`, params })

// 获取平均首帧时长的节目详情
export const getAvgFirstFrameDelayProgramDetailApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/first-frame-delay/avg/date/list`, params })

// 获取首帧时长的节目详情
export const getFirstFrameDelayProgramDetailApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/first-frame-delay/date/list`, params })

// 播放体验分析
// 获取播放体验分析列表
export const getPlaybackExperienceAnalysisListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/play-experience`, params })

// 获取卡顿率统计
export const getLaggingRateStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/lagging-rate`, params })

// 获取秒开率统计
export const getInstantOpenRateStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/instant-open-rate`, params })

// 获取秒开率统计列表
export const getInstantOpenRateListStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/instant-open-rate/list`, params })

// 获取秒开率详情列表
export const getInstantOpenRateDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/instant-open-rate/date/list`, params })

// 获取卡帧率详情
export const getLaggingRateDetailApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/lagging-rate/list`, params })

// 获取卡顿率的节目详情
export const getLaggingRateProgramDetailApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/lagging-rate/date/list`, params })

// 获取所有国家列表
export const getAllCountryListApi = (language: string) => live_instance({method: 'get', url: `/netfly-admin/v1/country/list`, params: {language} })

// 获取频道资源概况
export const getChannelResourceOverviewApi = () => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/resource-overview` })

// 获取所有频道实时在线人数
export const getOnlineUsersApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/online/count`, params })

// 获取实时在线榜单
export const getOnlineRankingListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/online/ranking`, params })

// 获取用户互动统计
export const getUserInteractionStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/user-interaction`, params })

// 获取跳出率统计
export const getBounceRateStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/jump-out-rate`, params })

// 获取跳出率统计列表
export const getBounceRateListStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/jump-out-rate/list`, params })

// 获取跳出率详情列表
export const getBounceRateDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/jump-out-rate/date/list`, params })

// 获取切换成功率统计
export const getSwitchingSuccessRateStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/switching-success-rate`, params })

// 获取切换成功率统计列表
export const getSwitchingSuccessRateListStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/switching-success-rate/list`, params })

// 获取切换成功率详情列表
export const getSwitchingSuccessRateDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/switching-success-rate/date/list`, params })

// 获取观看时长统计
export const getWatchingDurationStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/avg-viewing-duration`, params })

// 获取转码质量统计
export const getTranscodeQualityStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/transcode/quality`, params })

// 获取转码分布统计
export const getTranscodeDistributionStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/transcode/distribution`, params })

// 获取端到端延时统计
export const getEndToEndDelayStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/top-e2e-delay`, params })

// 获取频道切换延时统计
export const getChannelSwitchDelayStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/top-switching-delay`, params })

// 获取卡顿监控数据（表格） 时间维度
export const getLaggingMonitorDataApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/user-lagging-stats/time/list`, params })

// 获取卡顿监控数据（表格） 节目维度
export const getLaggingMonitorProgramDataApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/user-lagging-stats/channel/list`, params })

// 获取卡顿监控数据（折线图）时间维度
export const getLaggingMonitorLineChartApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/user-lagging-stats-per500/time/list`, params })

// 获取卡顿监控数据（折线图）多频道维度 不区分CDN类型
export const getLaggingMonitorProgramChartApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/user-lagging-stats-per500/channel/all/list`, params })

// 获取卡顿监控数据（折线图）单频道维度 区分CDN类型
export const getLaggingMonitorSingleProgramChartApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/user-lagging-stats-per500/channel/one/list`, params })

// 获取卡顿监控详情数据
export const getLaggingMonitorDetailApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/user-lagging-stats/time/date/list`, params })

// 获取卡顿次数统计列表
export const getLaggingCountListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/channel-lagging-stats/list`, params })

// 获取实时在线人数列表
export const getLiveOnlineUsersListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/online/list`, params })

// 获取频道利用率详情列表
export const getChannelUtilizationDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/utilization/list`, params })

// 获取频道闲置率详情列表
export const getChannelIdleRateDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/idle/list`, params })

// 获取平均观看时长统计列表
export const getLiveAverageWatchingDurationListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/avg-viewing-duration/list`, params })

// 获取平均观看时长详情列表
export const getLiveAverageWatchingDurationDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/avg-viewing-duration/date/list`, params })

// 获取完整转码频道列表
export const getCompleteTranscodeChannelListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/transcode/quality/list`, params })

// 获取转码分布列表
export const getTranscodeDistributionListApi = (params) => live_instance({method: 'get', url: `/netfly-admin//v1/live/statistics/resolution/distribution/list`, params })

// 获取转码分布详情列表
export const getTranscodeDistributionDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/resolution/distribution/date/list`, params })

// 获取端到端切换延时详情列表
export const getEtoEDelayDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/e2e-delay/list`, params })

// 获取频道切换延时详情列表
export const getChannelSwitchDelayDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/switching-delay/list`, params })

// 获取节目维度统计信息
export const getProgramDimensionStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/channel/comprehensive/list`, params })

// 获取用户维度统计信息
export const getUserDimensionStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/user/comprehensive/list`, params })

// 获取首帧平均时长的全部折线图数据
export const getFirstFrameAverageDurationLineChartApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/first-frame-delay/avg/all/list`, params })

// 获取平均观看时长全部折线图数据
export const getAverageWatchingDurationLineChartApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/avg-viewing-duration/all/list`, params })

// 获取首帧延迟全部折线图数据
export const getFirstFrameDelayLineChartApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/first-frame-delay/avg/all/list`, params })

// 获取卡顿率全部折线图数据
export const getLaggingRateLineChartApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/lagging-rate/all/list`, params })

// 获取跳出率全部折线图数据
export const getBounceRateLineChartApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/jump-out-rate/all/list`, params })

// 获取切换成功率全部折线图数据
export const getSwitchingSuccessRateLineChartApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/switching-success-rate/all/list`, params })

// 获取秒开率全部折线图数据
export const getInstantOpenRateLineChartApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/instant-open-rate/all/list`, params })

// 获取转码分布全部折线图数据
export const getTranscodeDistributionLineChartApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/resolution/distribution/all/list`, params })

// 获取转码码率分布
export const getTranscodeRateDistributionApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/live/statistics/resolution/distribution`, params })

/**========================================================点播节目============================================================ */
// 获取点播资源概况
export const getVodResourceOverviewApi = () => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/program-overview` })

// 获取完播率
export const getVodCompletionRateApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/completion-rate`, params })

// 获取弃播率
export const getVodAbandonRateApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/abort-rate`, params })

// 获取重复观看率
export const getVodRepeatViewRateApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/repeat-rate`, params })

// 获取播放体验分析列表
export const getVodPlaybackExperienceAnalysisListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/play-experience`, params })

// 获取平均观看时长
export const getVodAverageWatchingDurationApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/avg-play-duration`, params })

// 获取平均首帧时长
export const getVodAverageFirstFrameDurationApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/first-frame-duration`, params })

// 获取实时在线榜单
export const getVodOnlineRankingListApi = () => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/online-ranking` })

// 获取首帧延迟分布情况
export const getVodFirstFrameDelayDistributionApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/first-frame-delay`, params })

// 获取完播率详情列表
export const getVodCompletionRateDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/completion-rate/detail`, params })

// 获取弃播率详情列表
export const getVodAbandonRateDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/abort-rate/detail`, params })

// 获取重复观看率详情列表
export const getVodRepeatViewRateDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/repeat-rate/detail`, params })

// 获取秒开率统计列表
export const getVodInstantOpenRateListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/instant-open-rate/list`, params })

// 获取错误率统计列表
export const getVodErrorRateListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/error-rate/list`, params })

// 获取卡顿率统计列表
export const getVodLaggingRateListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/lagging-rate/list`, params })

// 获取秒开率详情列表
export const getVodInstantOpenRateDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/instant-open-rate/date/list`, params })

// 获取错误率详情列表
export const getVodErrorRateDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/error-rate/date/list`, params })

// 获取卡顿率详情列表
export const getVodLaggingRateDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/lagging-rate/date/list`, params })

// 获取平均播放时长统计列表
export const getVodAverageWatchingDurationListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/avg-play-duration/list`, params })

// 获取平均播放时长详情列表
export const getVodAverageWatchingDurationDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/avg-play-duration/date/list`, params })

// 获取实时在线榜单的详情
export const getVodOnlineRankingDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/online/list`, params })

// 获取点播平均首帧时长统计列表
export const getVodAverageFirstFrameDurationListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/first-frame-delay/avg/list`, params })

// 获取点播平均首帧时长详情列表
export const getVodAverageFirstFrameDurationDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/first-frame-delay/avg/date/list`, params })

// 获取首帧延迟统计列表
export const getVodFirstFrameDetailListApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/first-frame-delay/list`, params })

// 获取延迟统计的某天统计列表
export const getVodFirstFrameListByDateApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/first-frame-delay/date/list`, params })

// 获取节目维度统计信息
export const getVodProgramDimensionStatisticsApi = (params) => live_instance({method: 'get', url: `/netfly-admin/v1/vod/statistics/comprehensive/list`, params })











